module.exports = __webpack_public_path__ + "media/images/about/b4-b41e2a3415279b0249e79d4b6b5dc40a.png";